module.exports = __webpack_public_path__ + "img/evaluacion_kl.91e38701.png";